// noinspection DuplicatedCode

import {Search} from 'js-search';
import {Runner, RunnerInterface} from '../models/runner';
import RunProvider from './run';
import {
    RUNS,
    RUN_FULL,
    RUN_HALF,
    RUN_RELAY,
} from '../models/waypoint';

export default class SearchProvider {
    static instance = null;

    private searches = new Map<number, Map<string, Search>>();

    private fields: Record<string, Array<string|Array<string>>> = {
        [RUN_FULL]: [
            'startNumber',
            'lastName',
            'firstName',
        ],
        [RUN_HALF]: [
            'startNumber',
            'lastName',
            'firstName',
        ],
        [RUN_RELAY]: [
            'startNumber',
            'lastName',
            'firstName',
            'relayName',
            ['runners', '0', 'lastName'],
            ['runners', '0', 'firstName'],
            ['runners', '1', 'lastName'],
            ['runners', '1', 'firstName'],
            ['runners', '2', 'lastName'],
            ['runners', '2', 'firstName'],
            ['runners', '3', 'lastName'],
            ['runners', '3', 'firstName'],
        ],
    };

    private runProvider: RunProvider;

    static getInstance(): SearchProvider {
        if (!this.instance) {
            this.instance = new SearchProvider();
        }

        return this.instance;
    }

    constructor() {
        this.runProvider = RunProvider.getInstance();

        this.runProvider.getYears().forEach((year) => {
            const runs: Map<string, Search> = new Map();

            RUNS.forEach((run: string) => {
                const search = new Search('startNumber');

                this.fields[run].forEach((field) => {
                    search.addIndex(field);
                });

                runs.set(run, search);
            });

            this.searches.set(year, runs);
        });
    }

    static getSearchWordsFromQuery(query: string): Array<string> {
        if (query === '') {
            return [];
        }

        // Einzelne Wörter getrennt nach Kommas und Leerzeichen
        return query
            .replace(/,/g, ' ')
            .toLowerCase()
            .trim()
            .split(/\s+/);
    }

    filterRunners(year: number, query: string, run: string): RunnerInterface[] {
        if (query === '') {
            return [];
        }

        if (!this.searches.get(year).get(run)) {
            // eslint-disable-next-line no-console
            console.error(`Search Index for '${run}' not found.`);
            return [];
        }

        const yearMap = this.searches.get(year);
        if (!yearMap) return [];
        
        const runSearch = yearMap.get(run);
        if (!runSearch) return [];
        
        return runSearch.search(query) as RunnerInterface[];
    }

    addRunner(runner: Runner) {
        let yearMap = this.searches.get(runner.year);
        if (!yearMap) {
            // Create the year map if it doesn't exist
            yearMap = new Map<string, Search>();
            RUNS.forEach((run: string) => {
                const search = new Search('startNumber');
                this.fields[run].forEach((field) => {
                    search.addIndex(field);
                });
                yearMap.set(run, search);
            });
            this.searches.set(runner.year, yearMap);
        }
        
        const runSearch = yearMap.get(runner.run);
        if (!runSearch) {
            console.error(`Search index for run '${runner.run}' in year '${runner.year}' not found.`);
            return;
        }
        
        runSearch.addDocument(runner);
    }
}
